import { useMemo } from "react";
import { createCustomEvent } from "./utils.js";
function validateEvent(tealiumClickEvent) {
  if (!tealiumClickEvent.data_element_id) {
    console.error("[Tealium] [Click]: data_element_id is required for Tealium tracking");
    return false;
  }
  if (tealiumClickEvent.data_description && tealiumClickEvent.data_description.length > 25) {
    console.error("[Tealium] [Click]: data_description must be 25 characters or less");
    return false;
  }
  if (tealiumClickEvent.Tracking_Type && !["link", "hiddenaction"].includes(tealiumClickEvent.Tracking_Type)) {
    console.error('[Tealium] [Click]: Tracking_Type must be either "link" or "hiddenaction"');
    return false;
  }
  if (!/^[a-zA-Z0-9_]+$/.test(tealiumClickEvent.data_element_id)) {
    console.error(
      "[Tealium] [Click]: data_element_id must contain only letters, numbers, and underscores"
    );
    return false;
  }
  if (tealiumClickEvent.data_description && !/^[a-zA-Z0-9_]+$/.test(tealiumClickEvent.data_description)) {
    console.error(
      "[Tealium] [Click]: data_description must contain only letters, numbers, and underscores"
    );
    return false;
  }
  return true;
}
function useDispatchTrackClickEvent() {
  const trackClickEventDispatcher = useMemo(() => {
    return (event) => {
      if (!validateEvent(event)) return;
      dispatchTrackEvent(event);
    };
  }, []);
  return trackClickEventDispatcher;
}
function dispatchTrackEvent(event) {
  try {
    const finalEvent = createCustomEvent({
      ...event,
      id: "Click"
    });
    globalThis.dispatchEvent(finalEvent);
  } catch (error) {
    console.error("[Tealium] Error dispatching track event:", error);
  }
}
export {
  useDispatchTrackClickEvent
};
//# sourceMappingURL=use-track-click-event.js.map
